import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from './core/auth/auth.service';
import { LoadingSpinnerComponent, NavBarComponent, ToastHostComponent } from '@shared/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingSpinnerComponent, NavBarComponent, ToastHostComponent],
  template: `
    @if (auth.isInitializing()) {
      <app-loading-spinner [fullPage]="true" />
    } @else {
      @if (auth.isAuthenticated()) {
        <app-nav-bar />
      }
      <main class="bg-[#faf6ed]">
        <router-outlet />
      </main>
    }
    <app-toast-host />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  protected readonly auth = inject(AuthService);
  private readonly msalService = inject(MsalService);

  ngOnInit(): void {
    // Chain initializeMsal inside complete so it only runs after the auth code is
    // exchanged. On non-redirect loads the observable completes immediately with null.
    this.msalService.handleRedirectObservable().subscribe({
      complete: () => this.auth.initializeMsal(),
      // Error during the auth-code exchange (hash mismatch, interaction_in_progress, network)
      // must not leave the app stuck on the loading spinner — initializeMsal clears it.
      error: () => this.auth.initializeMsal(),
    });
  }
}
